import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

const AuthContext = createContext({});

export const useAuth = () => {
 const context = useContext(AuthContext);
 if (!context) {
 throw new Error('useAuth must be used within an AuthProvider');
 }
 return context;
};

export const AuthProvider = ({ children }) => {
 const [user, setUser] = useState(null);
 const [loading, setLoading] = useState(true);

 useEffect(() => {
 // Check active sessions and sets the user
 supabase.auth.getSession().then(({ data: { session } }) => {
 setUser(session?.user ?? null);
 setLoading(false);
 });

 // Listen for changes on auth state
 const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
 setUser(session?.user ?? null);
 setLoading(false);
 });

 return () => subscription.unsubscribe();
 }, []);

 const signInWithGoogle = async () => {
 const redirectUrl = process.env.REACT_APP_AUTH_REDIRECT_URL || window.location.origin;
 const { error } = await supabase.auth.signInWithOAuth({
 provider: 'google',
 options: {
 redirectTo: redirectUrl,
 },
 });
 if (error) throw error;
 };

 const signOut = async () => {
 const { error } = await supabase.auth.signOut();
 if (error) throw error;
 };

 const value = {
 user,
 loading,
 signInWithGoogle,
 signOut,
 };

 return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

